/* eslint-disable no-nested-ternary */
import React from 'react'
import { Card, Fieldset, Heading } from '@vwfs-bronson/bronson-react'
import { useTranslation } from 'react-i18next'
import { FastField } from 'formik'
import { CheckboxField } from '../../../../../components/CheckboxField'
import { useSelector } from 'react-redux'
import {
  getOriginSystem,
  isAUDI,
  isVtiGiS,
} from '../../../../../services/common/utils'
import { getStorefrontData } from '../../../../../services/redux/features/storefront.redux'
import { markupBGB } from '../../../../../utils/utils'

const ExplanationComponent = () => {
  const { t } = useTranslation()
  const storefrontData = useSelector(getStorefrontData)

  return (
    <Card
      title={<Heading level={2}>{t('form:dataProtection:title')}</Heading>}
      className="u-text-left"
    >
      {isVtiGiS(storefrontData) && (
        <Fieldset.Row>
          <FastField
            name="acceptPrecontractualInformationVti"
            label={
              <span
                dangerouslySetInnerHTML={{
                  __html: t('form:dataProtection:vti:acceptPrecontractualInformationVti', {
                    companyName: storefrontData?.dealerData?.companyName,
                  }),
                }}
              />
            }
            required
            component={CheckboxField}
          />
        </Fieldset.Row>
      )}

      {isAUDI(storefrontData) && (
        <>
          <Fieldset.Row>
            <FastField
              name="acceptPrecontractualInformationDealer"
              label={
                <span>
                  {t(
                    `form:dataProtection:${getOriginSystem(
                      storefrontData
                    )}:explanationComponent:acceptPrecontractualInformationDealer:text1`
                  )}
                  <a
                    href={storefrontData?.dealerData?.preContractInformationUrl}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {t(
                      `form:dataProtection:${getOriginSystem(
                        storefrontData
                      )}:explanationComponent:acceptPrecontractualInformationDealer:link`
                    )}
                  </a>
                  {t(
                    `form:dataProtection:${getOriginSystem(
                      storefrontData
                    )}:explanationComponent:acceptPrecontractualInformationDealer:text2`,
                    {
                      companyName: storefrontData?.dealerData?.companyName,
                    }
                  )}
                </span>
              }
              required
              component={CheckboxField}
            />
          </Fieldset.Row>
          <Fieldset.Row>
            <FastField
              name="acceptSalesTerms"
              label={
                <span>
                  {t(
                    `form:dataProtection:${getOriginSystem(
                      storefrontData
                    )}:explanationComponent:acceptSalesTerms:text1`
                  )}
                  <a
                    href={storefrontData?.dealerData?.salesTermsUrl}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {t(
                      `form:dataProtection:${getOriginSystem(
                        storefrontData
                      )}:explanationComponent:acceptSalesTerms:link`
                    )}
                  </a>
                  {t(
                    `form:dataProtection:${getOriginSystem(
                      storefrontData
                    )}:explanationComponent:acceptSalesTerms:text2`,
                    {
                      companyName: storefrontData?.dealerData?.companyName,
                    }
                  )}
                </span>
              }
              required
              component={CheckboxField}
            />
          </Fieldset.Row>
          <Fieldset.Row>
            <span>
              {t(
                `form:dataProtection:${getOriginSystem(
                  storefrontData
                )}:explanationComponent:suffix:text1`
              )}
              <a
                href={storefrontData?.dealerData?.dataProtectionUrl}
                target="_blank"
                rel="noreferrer"
              >
                {t(
                  `form:dataProtection:${getOriginSystem(
                    storefrontData
                  )}:explanationComponent:suffix:link`
                )}
              </a>
              {t(
                `form:dataProtection:${getOriginSystem(
                  storefrontData
                )}:explanationComponent:suffix:text2`,
                {
                  companyName: storefrontData?.dealerData?.companyName,
                }
              )}
            </span>
          </Fieldset.Row>
        </>
      )}

      {isVtiGiS(storefrontData) && (
        <>
          <Fieldset.Row>
            <FastField
              name="acceptPurchaseConditionsVti"
              label={
                <span
                  dangerouslySetInnerHTML={{
                    __html: markupBGB(
                      t(`form:dataProtection:vti:acceptPurchaseConditionsVti`)
                    ),
                  }}
                />
              }
              required
              component={CheckboxField}
            />
          </Fieldset.Row>
          <Fieldset.Row>
            <FastField
              name="acceptInsuranceDocuments"
              label={
                <span
                  dangerouslySetInnerHTML={{
                    __html: t(
                      `form:dataProtection:vti:acceptInsuranceDocuments`
                    ),
                  }}
                />
              }
              required
              component={CheckboxField}
            />
          </Fieldset.Row>
          <Fieldset.Row className="u-mt">
            <Heading level={2}>
              {t('form:dataProtection:conditionsTitle')}
            </Heading>
          </Fieldset.Row>
          <Fieldset.Row>
            <p>{t('form:dataProtection:conditionsTextVti')}</p>
          </Fieldset.Row>
        </>
      )}
    </Card>
  )
}
export default ExplanationComponent
